import React from 'react'

import clsx from 'clsx'

import Button from 'components/Button'

import classes from './HomeButton.module.scss'

const HomeButton = props => {
  return <Button className={clsx('HomeButton', classes.root)} variant="outlined" {...props} />
}

export default HomeButton
